var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plan-header mb-4"},[_c('div',{staticClass:"plan-header__title"},[_vm._v(_vm._s(_vm.displayTitle))]),_vm._v(" "),_c('div',{staticClass:"plan-header__subtitle text-gray-950"},[_vm._v(_vm._s(_vm.displaySubtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }